<template>
  <CommonPanel title="核心数据" :needExtra="true">
    <span slot="extra" class="asideinfo">数据每小时更新：{{new Date() | dataFormat}}</span>
    <today-data />
    <realtime-rank />
  </CommonPanel>
</template>
<script>
  import CommonPanel from "@/components/common-panel/index"
  import moment from 'moment'
  import TodayData from './_todayData'
  import RealtimeRank from './_realtimeRank'
  export default {
    name: 'data-kanban',
    components: {
      CommonPanel,
      [TodayData.name]: TodayData,
      [RealtimeRank.name]: RealtimeRank
    },
    filters: {
      dataFormat(time) {
        return moment(time).format('YYYY-MM-DD HH:00:00')
      }
    }
  }
</script>
<style scoped>
  .asideinfo {
    color: #999999;
    font-size: 12px;
    font-family: MicrosoftYaHei, PingFangSC-Regular, PingFang SC;
  }
</style>
